import { render, staticRenderFns } from "./CompanyMobileOrdered.vue?vue&type=template&id=cb61ba9a"
import script from "./CompanyMobileOrdered.vue?vue&type=script&lang=js"
export * from "./CompanyMobileOrdered.vue?vue&type=script&lang=js"
import style0 from "./CompanyMobileOrdered.vue?vue&type=style&index=0&id=cb61ba9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports